export default "__VITE_ASSET__CP$Byhmf__"